import {NgModule} from '@angular/core';
import {ExtraOptions, PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {CatalogListComponent} from '@page/catalog-list/catalog-list.component';
import {CatalogIndexComponent} from '@page/catalog-index/catalog-index.component';
import {CatalogDetailComponent} from '@page/catalog-detail/catalog-detail.component';
import {ModelDetailComponent} from '@page/model-detail/model-detail.component';
import {ModelConfigurationComponent} from '@page/model-configuration/model-configuration.component';
import {SearchComponent} from '@page/search/search.component';
import {ModelDetailGridComponent} from '@page/model-detail-grid/model-detail-grid.component';
import {ModelDetailListComponent} from '@page/model-detail-list/model-detail-list.component';
import {UserAreaComponent} from '@page/user-area/user-area.component';
import {UserAreaCrmGuard} from '@app/guards/user-area/user-area-crm-guard.service';
import {SalesPolicyDisclaimerComponent} from '@page/sales-policy-disclaimer/sales-policy-disclaimer.component';
import {RoutingByCodeComponent} from '@page/routing-by-code/routing-by-code.component';
import {SessionUpdateComponent} from './components/session-update/session-update.component';
import {
  RegistrationPreactivationCodeComponent
} from '@page/registration-preactivation-code/registration-preactivation-code.component';
import {FreeSignupComponent} from '@page/free-signup/free-signup.component';
import {AccountActivatorComponent} from './components/account-activator/account-activator.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {RequestResetPasswordComponent} from './components/request-reset-password/request-reset-password.component';
import {NotAuthenticated} from '@app/guards/auth/not-authenticated.guard';
import {ComposerComponent} from './components/composer/composer.component';
import {listWithDetailParamMatcher} from './shared/utils/list.detail.param.matcher';
import {ComposerGuard} from '@app/guards/composer/composer.guard';
import {ComposerShellComponent} from '@app/model-composer';

const routerConfig: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled'
};

const routes: Routes = [
  {path: '', redirectTo: '/catalog-list', pathMatch: 'full'},
  {path: 'user-area', component: UserAreaComponent, canActivate: [UserAreaCrmGuard], data: {section: 'user-area'}},
  {matcher: (url) => listWithDetailParamMatcher(url, {
    listRoute: 'catalog-list',
    singleRoute: 'order',
    paramName: 'id'
  }), component: CatalogListComponent},
  {path: 'crm',  loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule), canActivate: [UserAreaCrmGuard], data: {section: 'crm'}},
  {path: 'catalog-index', component: CatalogIndexComponent},
  {path: 'catalog-detail/:id', component: CatalogDetailComponent},
  {path: 'model-detail/:id', component: ModelDetailComponent},
  {path: 'model-detail/:id/:categoryId', component: ModelDetailComponent},
  {path: 'model-detail-grid/:id', component: ModelDetailGridComponent},
  {
    path: 'model-detail-grid/:id/:categoryId',
    component: ModelDetailGridComponent
  },
  {
    path: 'model-detail-grid/:id/:categoryId/ETO/:etoId',
    component: ModelDetailGridComponent
  },
  {path: 'model-grid-code/:modelCode', component: RoutingByCodeComponent},
  {path: 'model-grid-code/:modelCode/:categoryCode', component: RoutingByCodeComponent},
  {path: 'model-detail-list/:id', component: ModelDetailListComponent},
  {
    path: 'model-detail-list/:id/:categoryId',
    component: ModelDetailListComponent
  },
  {
    path: 'model-configuration/:id',
    component: ModelConfigurationComponent
  },
  {
    path: 'model-composer-poc',
    component: ComposerComponent,
    canActivate: [ComposerGuard]
  },
  {
    path: 'model-composer/:modelId',
    component: ComposerShellComponent,
    canActivate: [ComposerGuard]
  },
  {
    path: 'model-composer/:modelId/:compositionId',
    component: ComposerShellComponent,
    canActivate: [ComposerGuard]
  },
  {
    path: 'model-configuration/:id/:actionOrConfigurationId',
    component: ModelConfigurationComponent
  },
  {
    path: 'model-configuration/:id/:actionOrConfigurationId/:otherId',
    component: ModelConfigurationComponent
  },
  {
    path: 'model-configuration-code/:productCode',
    component: RoutingByCodeComponent
  },
  {
    path: 'login/helper/password/reset',
    component: RequestResetPasswordComponent
  },
  {
    path: 'login/helper/password/reset/:token',
    component: ResetPasswordComponent
  },
  {path: 'login/helper/activation', component: AccountActivatorComponent},
  {path: 'register-code', component: RegistrationPreactivationCodeComponent},
  {path: 'register', component: FreeSignupComponent, canActivate: [NotAuthenticated]},
  {path: 'search', component: SearchComponent},
  {
    path: 'checkout',
    loadChildren: () => import('./pages/checkout/checkout.module').then(m => m.CheckoutModule)
  },
  {path: 'sale-policies', component: SalesPolicyDisclaimerComponent},
  {path: 'session/update/:sessionId', component: SessionUpdateComponent},
  {path: '**', redirectTo: '/catalog-list', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerConfig)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
